module.exports = __webpack_public_path__ + "static/media/t10.6596c991.jpg";